<div class='enterprise-configuration-main' data-cy="enterprise-config-container">
  <mat-grid-list *ngIf="enterprise !== undefined" cols="6" rowHeight="100%" style="height:100%;" data-cy="enterprise-config-grid">
    <mat-grid-tile colspan="4" data-cy="enterprise-config-tile">
      <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="enterprise-config-card">
        <mat-card-content data-cy="enterprise-config-content">

            <span class="configuration-section-title" data-cy="enterprise-config-title">Enterprise Information</span>
            <app-tdo-configuration-action-bar
              #actionBar
              [showEdit]="false"
              [saveDisabled]="false"
              [showSave]="true"
              [showCancel]="false"
              (saveClick)="onSave($event)"
              [showAdd]="false"
              [newHidden]="true"
              data-cy="enterprise-config-action-bar">
            </app-tdo-configuration-action-bar>

          <mat-tab-group style="height: 600px;" mat-align-tabs="start" (selectedTabChange)="onTabChange($event)" data-cy="enterprise-config-tabs">
            <mat-tab style="height: 100%; overflow-y: hidden;" label="Enterprise" data-cy="enterprise-config-enterprise-tab">
                <!--this should be plain text, not input disabled-->
              <div style="padding-top:10px" data-cy="enterprise-config-info-container">
                <div style="display: flex" data-cy="enterprise-config-name-container">
                  <div style="flex-basis: 90px; text-align: right;" data-cy="enterprise-config-name-label"><b>Name:</b></div>
                  <div style="flex-basis: 8px;"></div>
                  <div style="flex: 1" data-cy="enterprise-config-name-value">{{ this.enterpriseOrganization?.OrganizationName }}</div>
                </div>

                <div style="display: flex; padding-top:5px" data-cy="enterprise-config-description-container">
                  <div style="flex-basis: 90px; text-align: right;" data-cy="enterprise-config-description-label"><b>Description:</b></div>
                  <div style="flex-basis: 8px;"></div>
                  <div style="flex: 1" data-cy="enterprise-config-description-value">{{ this.enterpriseOrganization?.Description }}</div>
                </div>

                <div style=" padding-top:10px" data-cy="enterprise-config-edit-container">
                  <button (click)="openOrganizationDialog(false, this.enterprise.OrganizationID)" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="enterprise-config-edit-button">Edit Organization Information</button>
                </div>
                <div style="padding-top:20px" data-cy="enterprise-config-central-claim-container">
                  <mat-slide-toggle [(ngModel)]="enterprise.isCentralClaimManagement" data-cy="enterprise-config-central-claim-toggle">Is Central Claim Management</mat-slide-toggle>
                </div>
              </div>

            </mat-tab>
            <mat-tab style="height: 100%; overflow-y: hidden;" label="TDO" data-cy="enterprise-config-tdo-tab">
                <!--this should be plain text, not input disabled-->
              <div style=" padding-top:10px" data-cy="enterprise-config-tdo-info-container">
                <div style="display: flex" data-cy="enterprise-config-tdo-name-container">
                  <div style="flex-basis: 90px; text-align: right;" data-cy="enterprise-config-tdo-name-label"><b>Name:</b></div>
                  <div style="flex-basis: 8px;"></div>
                  <div style="flex: 1" data-cy="enterprise-config-tdo-name-value">{{ this.tdoOrganization?.OrganizationName }}</div>
                </div>

                <div style="display: flex; padding-top:5px" data-cy="enterprise-config-tdo-description-container">
                  <div style="flex-basis: 90px; text-align: right;" data-cy="enterprise-config-tdo-description-label"><b>Description:</b></div>
                  <div style="flex-basis: 8px;"></div>
                  <div style="flex: 1" data-cy="enterprise-config-tdo-description-value">{{ this.tdoOrganization?.Description }}</div>
                </div>

                <div style=" padding-top:10px" data-cy="enterprise-config-tdo-view-container">
                  <button (click)="openOrganizationDialog(true, this.enterprise.TDOcOrganizationID)" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="enterprise-config-tdo-view-button">View Organization Information</button>
                </div>
              </div>

            </mat-tab>
          </mat-tab-group>

        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>


